<template>
  <div class="action-config-item contact-config">
    <div class="mb-4">
      <label for="action-name" class="block text-sm font-semibold text-gray-700">Action Name</label>
      <el-input
        v-model="localStep.label"
        id="action-name"
        placeholder="Enter Action Name"
        clearable
        class="w-full rounded-md"
      />
    </div>
    <el-button
      class="contact-config-btn"
      type="text"
      icon="el-icon-s-tools"
      @click="openContactModal()"
    >
      Configure
    </el-button>

    <!-- Footer Actions -->
    <div class="automation-footer-actions mt-4 flex justify-end gap-2">
      <el-button @click="cancelChanges">Cancel</el-button>
      <el-button type="primary" @click="saveChanges">Save</el-button>
    </div>
    <dialog-component
      :visible="createContactModal"
      title="Map Fields"
      @before-close="handleClose()"
      :containerWidth="'30%'"
      :containerHeight="'auto'"
    >
      <div class="contact-grid">
        <!-- First Name -->
        <div class="contact-field">
          <label>
            First Name
            <span class="required">*</span>
          </label>
          <el-select v-model="contactFormData.first_name" placeholder="Select First Name" clearable>
            <el-option
              v-for="(field, i) in getFields(['SINGLE_LINE_TEXT'])"
              :key="field.key + i"
              :value="field.key"
              :label="field.label"
            />
          </el-select>
        </div>

        <!-- Last Name -->
        <div class="contact-field">
          <label>
            Last Name
            <span class="required">*</span>
          </label>
          <el-select v-model="contactFormData.last_name" placeholder="Select Last Name" clearable>
            <el-option
              v-for="(field, i) in getFields(['SINGLE_LINE_TEXT'])"
              :key="field.key + i"
              :value="field.key"
              :label="field.label"
            />
          </el-select>
        </div>

        <!-- Email -->
        <div class="contact-field">
          <label>
            Email
            <span class="required">*</span>
          </label>
          <el-select v-model="contactFormData.email" placeholder="Select Email" clearable>
            <el-option
              v-for="(field, i) in getFields(['EMAIL'])"
              :key="field.key + i"
              :value="field.key"
              :label="field.label"
            />
          </el-select>
        </div>

        <!-- Phone Number -->
        <div class="contact-field">
          <label>Phone Number</label>
          <el-select
            v-model="contactFormData.phone_number"
            placeholder="Select Phone Number"
            clearable
          >
            <el-option
              v-for="(field, i) in getFields(['PHONE_COUNTRY_CODE'])"
              :key="field.key + i"
              :value="field.key"
              :label="field.label"
            />
          </el-select>
        </div>

        <!-- Address -->
        <div class="contact-field">
          <label>Address</label>
          <el-select v-model="contactFormData.address" placeholder="Select Address" clearable>
            <el-option
              v-for="(field, i) in getFields(['SINGLE_LINE_TEXT'])"
              :key="field.key + i"
              :value="field.key"
              :label="field.label"
            />
          </el-select>
        </div>

        <!-- Company Name -->
        <div class="contact-field">
          <label>Company Name</label>
          <el-select
            v-model="contactFormData.company_name"
            placeholder="Select Company Name"
            clearable
          >
            <el-option
              v-for="(field, i) in getFields(['SINGLE_LINE_TEXT'])"
              :key="field.key + i"
              :value="field.key"
              :label="field.label"
            />
          </el-select>
        </div>

        <!-- Title (Full Width) -->
        <div class="contact-field full-width">
          <label>Title</label>
          <el-select v-model="contactFormData.title" placeholder="Select Title" clearable>
            <el-option
              v-for="(field, i) in getFields(['SINGLE_LINE_TEXT'])"
              :key="field.key + i"
              :value="field.key"
              :label="field.label"
            />
          </el-select>
        </div>
      </div>

      <span slot="footer" class="dialog-footer contact-footer">
        <el-button @click="handleClose">Close</el-button>
        <el-button
          type="primary"
          :disabled="checkContactSaveDisable"
          @click="saveContactConfigurations"
        >
          Save
        </el-button>
      </span>
    </dialog-component>
  </div>
</template>

<script>
  import { getFieldsByType } from '../actionHelper';
  import StepEditableMixin from './StepEditableMixin';
  export default {
    name: 'CreateContactAction',
    props: {
      step: Object,
      allFields: Array,
    },
    mixins: [StepEditableMixin],
    data() {
      return {
        contactFormData: {},
        createContactModal: false,
      };
    },
    computed: {
      checkContactSaveDisable() {
        return !(
          this.contactFormData.first_name &&
          this.contactFormData.last_name &&
          this.contactFormData.email
        );
      },
    },
    methods: {
      openContactModal() {
        if (this.localStep['contact_config']) {
          this.contactFormData = { ...this.localStep.contact_config };
        } else {
          this.contactFormData = {};
        }
        this.createContactModal = true;
      },
      handleClose() {
        this.createContactModal = false;
      },
      getFields(types) {
        return getFieldsByType(types, this.allFields);
      },
      saveContactConfigurations() {
        this.$set(this.localStep, 'contact_config', this.contactFormData);
        this.createContactModal = false;
      },
    },
  };
</script>

<style scoped>
  .contact-config-btn {
    font-weight: 500;
    border-radius: 6px;
    padding: 0.4rem 0.8rem;
    transition: all 0.2s ease;
  }
  .contact-config-btn:hover {
    background-color: #f5f7fa;
  }

  .contact-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    padding: 10px;
  }

  .contact-field {
    display: flex;
    flex-direction: column;
  }

  .full-width {
    grid-column: span 2;
  }

  .contact-field label {
    font-size: 13px;
    font-weight: 500;
    margin-bottom: 4px;
    color: #333;
  }

  .required {
    color: red;
  }

  .contact-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
</style>
